export default "__VITE_ASSET__k8VR9hzk__"